export const messages = {
  title: {
    id: 'admin/promotions.form.regular.view.benefit.free-shipping.title',
  },
  free: {
    id: 'admin/promotions.form.regular.view.benefit.free-shipping',
  },
}
